
import Vue from "vue"
import * as am4core from "@amcharts/amcharts4/core"
import * as am4charts from "@amcharts/amcharts4/charts"
import am4themes_animated from "@amcharts/amcharts4/themes/animated"
import Component from "vue-class-component"
import {Prop} from "vue-property-decorator"
import {MetricSliced, MetricStore} from "@/cube/metric-data/MetricStore"
import {MemberDimension, MemberSnapshotMeasure} from "@/cube"
import {removeDimensionSortPrefix} from "@/cube/removeDimensionSortPrefix"

@Component
export default class PieChart extends Vue {
  @Prop()
  metricStore: MetricStore

  metricData: MetricSliced<any>

  chart: am4charts.PieChart

  async created() {
    this.metricData = this.metricStore.getSliced(
      MemberSnapshotMeasure.countMembers,
      [MemberDimension.gender]
    )

    this.$watch(
      () => this.metricData.end,
      () => {
        if (this.metricData.end) {
          this.metricData.end.forEach(row => {
            row[MemberDimension.gender] = removeDimensionSortPrefix(
              row[MemberDimension.gender]
            )
          })
          this.createChart()
        }
      }
    )
  }

  createChart() {
    am4core.useTheme(am4themes_animated)

    this.chart = am4core.create((<any>this.$refs).chart, am4charts.PieChart)
    this.chart.data = this.metricData.end ?? <any>[]

    let pieSeries = this.chart.series.push(new am4charts.PieSeries())
    pieSeries.dataFields.value = "MemberSnapshot.countMembers"
    pieSeries.dataFields.category = "Member.gender"
    pieSeries.slices.template.stroke = am4core.color("#fff")
    pieSeries.slices.template.strokeWidth = 2
    pieSeries.slices.template.strokeOpacity = 1

    // This creates initial animation
    pieSeries.hiddenState.properties.opacity = 1
    pieSeries.hiddenState.properties.endAngle = -90
    pieSeries.hiddenState.properties.startAngle = -90
  }
}
